import { FilingStatus } from './filingStatus'

// Structural shape needed to derive filing status. Deliberately narrow —
// only the household inputs the IRS status decision actually depends on:
// marital status, joint-filing election, and whether any dependents exist
// (which promotes a single filer to Head of Household).
export interface FilingStatusHousehold {
  maritalStatus: 'single' | 'married'
  filingJointly: boolean
  minorChildren: { length: number }
  otherDependents: { length: number }
}

export const getFilingStatus = (
  household: FilingStatusHousehold
): FilingStatus => {
  if (household.maritalStatus === 'single') {
    const hasDependents =
      household.minorChildren.length > 0 || household.otherDependents.length > 0
    return hasDependents ? FilingStatus.HEAD_OF_HOUSEHOLD : FilingStatus.SINGLE
  }

  return household.filingJointly
    ? FilingStatus.MARRIED_FILING_JOINTLY
    : FilingStatus.MARRIED_FILING_SEPARATELY
}
